export default __webpack_public_path__ + "static/media/element_33.db802ea4.jpg";